import React from "react";
import { Header } from "./Introduce";
import styles from "../css/Culture.css";


const app = () => {
    return (
        <div style={{ flex: 1 }}>
            <Header text="实验室介绍"></Header>
            <div className={styles.main}>
                <div className={styles.top}>
                    <p className={styles.title}>
                        实验室文化
                    </p>
                    <div style={{ "marginTop": "15px" }}>
                        <p className={styles.subTitle}>
                            准确可靠，品质服务传递信任
                        </p>

                        <p className={styles.subTitle}>
                            科学公正，专业技术创造价值
                        </p>
                    </div>

                </div>

                <div className={styles.bottom}>
                    <p className={styles.bottomTitle}>实验室logo介绍</p>

                    <div className={styles.content}>
                        <p className={styles.contentP}>
                            <img src="https://tsinghua-wechat-hq.oss-cn-beijing.aliyuncs.com/4361652168666_.pic.jpg" className={styles.img} ></img>
                            <span style={{"fontWeight":600}}>主体设计为：</span>  色谱和顶空样品瓶的形状，样品瓶的右上侧和左下侧有开口，与Separation的首字母S相似，意为分离是色谱分析的核心；开口处分别延伸出色谱图和质谱棒，其中色谱图中不同颜色的峰与提出“色谱法”时的谱带相呼应，质谱图展现了不同类型的棒状图；样品瓶盖上的清华大学简称THU与瓶内的色谱质谱图和Separation字样代表了我们是在清华大学主管下的以色谱质谱测试为主要内容的实验室。
                        </p>


                    </div>
                </div>

            </div>
        </div>
    );
};

export default app;



// WEBPACK FOOTER //
// ./src/pages/Culture.js